import { Button, IconButton } from "@mui/material";
import { jobExplorer, JobSelectionType } from "common/state/jobExplorer";
import { NumberedTractorIcon } from "common/components/map/NumberedTractorIcon";
import { RobotSummary } from "protos/rtc/location_history";
import { SelectionButton } from "portal/components/map/navigation/SelectionButton";
import { theme } from "portal/theme/theme";
import { useDispatch, useSelector } from "react-redux";
import React, { FC } from "react";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityOnIcon from "@mui/icons-material/Visibility";

interface RobotPanelProps {
  robots: RobotSummary[];
}
export const RobotPanel: FC<RobotPanelProps> = ({ robots }) => {
  const { setHiddenTractors, hideTractor, setSelection, setFocus } =
    jobExplorer.actions;
  const colorsBySerial = useSelector(
    jobExplorer.selectors.selectColorsBySerial
  );
  const dispatch = useDispatch();

  const focus = useSelector(jobExplorer.selectors.selectFocus);
  const selection = useSelector(jobExplorer.selectors.selectSelection);
  const hiddenTractors = useSelector(
    jobExplorer.selectors.selectHiddenTractors
  );

  const isTractorFocused = (serial: string): boolean => {
    return (
      focus?.type === JobSelectionType.TRACTOR &&
      focus.selection.serial === serial
    );
  };
  const isTractorSelected = (serial: string): boolean => {
    return (
      selection?.type === JobSelectionType.TRACTOR &&
      selection.selection.serial === serial
    );
  };
  const toggleVisibility = (serial: string): void => {
    if (hiddenTractors.includes(serial)) {
      dispatch(setHiddenTractors(hiddenTractors.filter((s) => s !== serial)));
    } else {
      dispatch(hideTractor(serial));
    }
  };
  return (
    <div>
      {robots.map((t) => (
        <Button
          key={t.serial}
          fullWidth
          className="flex relative"
          onMouseEnter={() =>
            dispatch(setFocus({ type: JobSelectionType.TRACTOR, selection: t }))
          }
          onMouseLeave={() => dispatch(setFocus(undefined))}
        >
          <SelectionButton
            subSection
            isFocused={isTractorFocused(t.serial)}
            isSelected={isTractorSelected(t.serial)}
            onClick={() =>
              dispatch(
                setSelection({
                  type: JobSelectionType.TRACTOR,
                  selection: t,
                })
              )
            }
            startIcon={
              <NumberedTractorIcon
                serial={t.serial}
                color={colorsBySerial[t.serial] ?? theme.colors.white}
                fontSize={16}
              />
            }
          >
            {t.serial}
          </SelectionButton>
          {isTractorFocused(t.serial) && (
            <IconButton
              className="absolute right-2 top-1/2 -translate-y-1/2 text-white z-10"
              onClick={() => toggleVisibility(t.serial)}
            >
              {hiddenTractors.includes(t.serial) && (
                <VisibilityOffIcon className="h-4 w-4" />
              )}
              {isTractorFocused(t.serial) &&
                !hiddenTractors.includes(t.serial) && (
                  <VisibilityOnIcon className="h-4 w-4" />
                )}
            </IconButton>
          )}
        </Button>
      ))}
    </div>
  );
};
